export const NEXT_UP_VISIBLE_BIRTHDAYS_COUNT = 3;
